module.exports = __webpack_public_path__ + "img/category_family.7125300.png";